/* import __COLOCATED_TEMPLATE__ from './content-source-row.hbs'; */
/* RESPONSIBLE TEAM: team-ai-agent */

import Component from '@glimmer/component';
import { inject as service } from '@ember/service';

export interface ContentSourceRowArgs {
  icon: $TSFixMe;
  onClick: () => void;
  disabled?: boolean;
  disabledTooltip?: string;
  faviconUrl?: string;
}

export interface ContentSourceRowSignature {
  Args: ContentSourceRowArgs;
  Blocks: {
    name: [];
    statusLabel: [];
    dropdownActions: [];
  };
  Element: Element;
}

export default class ContentSourceRow extends Component<ContentSourceRowSignature> {
  @service declare appService: any;
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'FinAiAgent::Knowledge::ContentSourceRow': typeof ContentSourceRow;
  }
}
